export const removeFromArray = <T>(arr: Array<T> | T[], index: number): T[] => {
  if (!arr) {
    return [];
  }

  return [...arr.slice(0, index), ...arr.slice(index + 1)];
};
